// TODO Ignored with eslint-interactive on 2023-11-10
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const questionsConst: any = {
    1: 'Strokovnost zdrastvenega osebja:',
    2: 'Dostopnost ambulante:',
    3: 'Prijaznost osebja ambulante:',
    4: 'Odzivnost ambulante:',
};
